
import type { EhrModule } from "../types/general/EhrModule";
import type { EhrTile } from "../types/general/EhrTile";

import SectionCard from "./SectionCard.vue";
import Vue from "vue";
import EhrNavigation from "./interface/EhrNavigation.vue";
import {moduleRepository} from "./repositories/moduleRepository";

declare var GLOBAL_applicationName: string;

interface Data {
  modules: EhrModule[];
  tiles: EhrTile[];
}

export default Vue.extend({
  name: "home-component",
  components: { SectionCard, EhrNavigation },

  created: function() {
    this.getData();
  },
  data(): Data {
    return {
      modules: [],
      tiles: [],
    };
  },
  computed: {
    applicationName() {
      return GLOBAL_applicationName;
    },
  },
  methods: {
    async getData(): Promise<void> {
      const {modules, tiles} = await moduleRepository.ehrModulesAndTiles();
      this.modules = modules;
      this.tiles = tiles;
    },
  },
});
